import {
  Button,
  Header,
  HeaderButton,
  HeaderCombobox,
  // HeaderCombobox,
  HeaderContent,
  HeaderLogo,
} from "@mozioinc/ui";
import { url } from "@mozioinc/utils";
// import { useQuery } from "@tanstack/react-query";
// import { useState } from "react";
// import { useTranslation } from "react-i18next";
// import { currencyQuery } from "../utils/query";
import { useSearch } from "@tanstack/react-router";
import posthog from "posthog-js";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ResendConfirmationDialog } from "../components/resend-confirmation-dialog";
import { rootRoute } from "../routes/root";
import { getWhiteLabel } from "../utils/white-label";
import type { TransNamespace } from "../types";

const HeaderContainer = () => {
  const { t } = useTranslation<TransNamespace>("parking:home");
  const parkingUrl = "/parking";
  const esimUrl = "/esim";
  const transferUrl = "/";
  // cspell:disable
  // const languages = [
  //   {
  //     label: "English",
  //     value: "english",
  //     locale: "en_US",
  //     href: url.setParam("locale", "en_US"),
  //   },
  //   {
  //     label: "Italiano",
  //     value: "italiano",
  //     locale: "it_IT",
  //     href: url.setParam("locale", "it_IT"),
  //   },
  // ];
  // cspell:enable

  const { header } = getWhiteLabel();
  const { currency } = useSearch({ strict: false });
  posthog.register({ displayed_currency: currency });

  // const { i18n } = useTranslation();
  // const { currency } = useCurrency();
  const [currencyMenuOpen, setCurrencyMenuOpen] = useState(false);
  // const currenciesQuery = useQuery({
  //   queryKey: ["currencies", currencyMenuOpen, i18n.language],
  //   queryFn: currencyQuery.getCurrencies,
  //   enabled: currencyMenuOpen,
  // });

  // TODO: Get currencies from API
  const currencies = [
    {
      href: url.setParam("currency", "USD"),
      value: "usd",
      code: "USD",
      label: "USD - US Dollar",
    },
    {
      href: url.setParam("currency", "EUR"),
      value: "eur",
      code: "EUR",
      label: "EUR - Euro",
    },
    {
      href: url.setParam("currency", "GBP"),
      value: "gbp",
      code: "GBP",
      label: "GBP - British Pound",
    },
  ];

  // const currencies =
  //   currenciesQuery.data?.map((c) => ({
  //     ...c,
  //     href: url.setParam("currency", c.code),
  //     value: `${c.code} - ${c.name}`.toLowerCase(),
  //     label: `${c.code} - ${c.name}`,
  // })) || [];

  // const currentLanguage =
  //   languages.find((l) => l.locale === i18n.language) ?? languages[0]!;

  const currentCurrency =
    currencies.find((c) => c.code === currency) ?? currencies[0]!;

  // const currentCurrencyCode = currentCurrency?.code || currency;
  const [openResendDialog, setOpenResendDialog] = useState(false);

  return (
    <Header className="fixed inset-x-0 top-0">
      <HeaderLogo href={parkingUrl}>
        <img src={header.logo} alt="logo" />
      </HeaderLogo>

      <HeaderContent>
        {/* <HeaderButton>Resend Booking</HeaderButton> */}

        <HeaderButton asChild>
          <Button
            variant={"solid"}
            onClick={() => {
              setOpenResendDialog(true);
            }}
            className="text-black"
          >
            {t("Resend Booking")}
          </Button>
        </HeaderButton>

        {header.showTransfers && (
          <HeaderButton asChild>
            <a href={transferUrl}>{t("Transfers")}</a>
          </HeaderButton>
        )}

        <HeaderButton asChild>
          <a href={parkingUrl}>{t("Parking")}</a>
        </HeaderButton>

        {header.showESim && (
          <HeaderButton asChild>
            <a href={esimUrl}>{t("eSIM")}</a>
          </HeaderButton>
        )}

        {/* <HeaderCombobox
          value={currentLanguage.value}
          triggerText={currentLanguage.label}
          label="Language"
          items={languages}
          onValueChange={(value) => {
            window.location.href = languages.find(
              (l) => l.value === value,
            )!.href;
          }}
        /> */}

        <HeaderCombobox
          value={currentCurrency.value}
          triggerText={currentCurrency.code}
          label="Currency"
          items={currencies}
          open={currencyMenuOpen}
          shouldFilter
          onValueChange={(value) => {
            window.location.href = currencies.find(
              (l) => l.value === value,
            )!.href;
          }}
          onOpenChange={setCurrencyMenuOpen}
        />

        {/* <HeaderButton color={HEADER_ITEM_COLOR.PRIMARY}>Sign In</HeaderButton> */}
      </HeaderContent>

      <ResendConfirmationDialog
        open={openResendDialog}
        onClose={() => {
          setOpenResendDialog(false);
        }}
      />
    </Header>
  );
};

export { HeaderContainer as Header };
